import { ListGroup, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import keycloakService from "../../modules";

function ConsentBox(props) {
    const { showConsent , kycUrl , setShowConsent, setShowWithoutDigilocker } = props
    
    const handleClose = () => {
        window.location.href = kycUrl
    }

    return (
        <>
            <Modal show={showConsent} onHide={() => keycloakService.doLogout()} animation={false}>
                {/* <OverlayTrigger
                    placement="right"
                    overlay={
                        <Tooltip id="logout-tooltip">
                            Clicking this button will log you out.
                        </Tooltip>
                    }
                > */}
                <Modal.Header closeButton className="border-0 pb-0">
                    <Modal.Title className="fw-bold fs-5 d-flex align-items-center gap-2">
                        Note: 
                            <OverlayTrigger
                                placement="bottom"
                                trigger={["hover", "focus"]}
                                overlay={
                                    <Tooltip id="logout-tooltip">
                                        Clicking this button will log you out.
                                    </Tooltip>
                                }
                            >
                                <span
                                    style={{
                                        cursor: "pointer",
                                        color: "#0f4f96",
                                        fontSize: "16px"
                                    }}
                                >
                                </span> 
                            </OverlayTrigger>
                    </Modal.Title>
                </Modal.Header>
                {/* </OverlayTrigger> */}
                <Modal.Body>
                    <ListGroup as="ul" numbered >
                        <ListGroup.Item>To continue with the MAH-CET application, Aadhaar and APAAR ID authentication is Preferred.</ListGroup.Item>
                        <ListGroup.Item>Please ensure that both your Aadhaar and APAAR ID are available in your DigiLocker account and that you have granted access to MAH-CET.</ListGroup.Item>
                        <ListGroup.Item>Use DigiLocker to complete the authentication of your Aadhaar and APAAR details.</ListGroup.Item>
                        <ListGroup.Item>If you are unable to authenticate Aadhaar and APAAR Please <span style={{color:'#0f4f96' , cursor:'pointer' , textDecoration:'underline'}} onClick={()=>{
                            setShowWithoutDigilocker(true)
                            setShowConsent(false)
                        }}>click here</span></ListGroup.Item>
                    </ListGroup>

                </Modal.Body>
                <Modal.Footer>

                    <Button variant="primary" onClick={handleClose}>
                        Proceed to Digilocker
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default ConsentBox;